import * as auth from "./auth";
import * as carriers from "./carriers";
import * as customers from "./customers";
import * as faraday from "./faraday";
import * as forms from "./forms";
import * as imports from "./imports";
import * as messaging from "./messaging";
import * as notices from "./notices";
import * as automations from "./automations";
import * as claims from "./claims";
import * as payments from "./payments";
import * as selfservice from "./selfservice";
import * as extras from "./extras";
import * as setup from "./setup";

/** Per-feature dictionaries, merged over the base dictionary in ../i18n.ts. Each stream owns one file. */
const modules = [setup, imports, forms, carriers, auth, messaging, faraday, customers, notices, automations, claims, payments, selfservice, extras];
export const extraEn: Record<string, string> = Object.assign({}, ...modules.map((m) => m.en));
export const extraEs: Record<string, string> = Object.assign({}, ...modules.map((m) => m.es));
